import _ from 'lodash'
import Backbone from 'backbone'
import nestCollection from 'scoreboard/components/nest-collection'
import KeySets from './key-sets'

const urlRoot = 'api/dataset-trees'
/**
 * @typedef RollupTree
 *
 * @property {Number} id
 * @property {String} treeLabel Only available on the tree root, the name of the rollup tree
 * @property {String} label The name of the tree node
 */
var RollupTree = Backbone.Model.extend({

	section: 'datasets',
	domainType: 'dataset-tree',
	urlRoot,

	initialize: function(options) {
		this.keySets = new KeySets(this.get('keySets'))
		nestCollection({
			parent: this,
			parentAttribute: 'keySets',
			children: this.keySets
		})
	},

	toJSON: function() {
		var data = Backbone.Model.prototype.toJSON.apply(this)
		// Prevent these attributes from being POST/PUT
		return _.omit(data, ['principals'])
	}

})

export default RollupTree
export { urlRoot }

RollupTree.__filename__ = 'admin/datasets/rollup-tree.js'
